



















































import { VoucherIdentifiable, Voucher, EventJson, Event } from 'inscreva-sse-models';
import { SortBy, Priority, FilterBy } from 'ss-commons-front/src/components/SortTable.vue';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import VoucherList from '@/components/VoucherList.vue';
import { paginationStore } from '@/store/pagination';
import { sessionStore } from '@/store/session';

import EmptyEventMessage from '../components/EmptyEventMessage.vue';
import Pagination from '../components/Pagination.vue';
import toast from '../components/toast';
import { ToastType } from '../components/toast/tost-type.enum';
import { subscriptionStore } from '../store/subscription';

const { QrcodeStream } = require('vue-qrcode-reader');

@Component({
  components: {
    Loading,
    VoucherList,
    QrcodeStream,
    Pagination,
    EmptyEventMessage,
  },
})
export default class ActivatePage extends Vue {
  private isLoading: boolean = true;

  private vouchers: Array<VoucherIdentifiable> = new Array<VoucherIdentifiable>();

  search: any = null;

  private sortBy: SortBy<Voucher> = {
    key: 'code',
    priority: Priority.ASC,
  } as SortBy<Voucher>;

  private filterBy: FilterBy<Voucher> = {
    page: 1,
    limit: paginationStore.limit,
  } as FilterBy<Voucher>;

  async created() {
    await this.list();
  }

  async list() {
    this.isLoading = true;
    this.vouchers = ((await subscriptionStore.listVouchers()) || []) as Array<VoucherIdentifiable>;
    this.isLoading = false;
  }

  get vouchers_filtered() {
    if (!this.search) {
      return this.vouchers;
    }
    return this.vouchers.filter(
      ({ code, extraInfo }) =>
        code.includes(this.search) ||
        extraInfo?.nome?.includes(this.search) ||
        extraInfo?.cpf?.includes(this.search) ||
        extraInfo?.email?.includes(this.search),
    );
  }

  get vouchers_paginated() {
    return this.vouchers_filtered.slice(
      ((this.filterBy.page || 1) - 1) * (this.filterBy.limit || 0),
      this.filterBy.limit * (this.filterBy.page || 1),
    );
  }

  changeFilter($event: any) {
    this.search = ($event.target.value || '').replace(/(?<=\d)[.\-\/](?=\d)/g, '');
  }

  async activate(voucher: VoucherIdentifiable) {
    toast(`Ativando o voucher ${voucher.code}...`, ToastType.INFO);
    await subscriptionStore
      .activate(voucher)
      .then(() => toast(`Voucher ativado !`, ToastType.SUCESS))
      .catch((error) => toast(`Não foi possível ativar o voucher ! ${error?.message || ''}`, ToastType.ERROR));
    await this.list();
  }

  sortList(sortBy: SortBy<Voucher>) {
    this.sortBy = sortBy;
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  onDecode(qrcode: string) {
    const voucher = this.vouchers.find(({ code }) => code === qrcode);
    if (voucher) {
      return this.activate(voucher);
    }
  }

  changeLimit($event: any) {
    const limit: number = $event.target.value;
    this.filterBy.limit = limit;
    paginationStore.changeLimit(limit);
  }
}
